<template>
  <b-modal
    id="new_bed"
    title="NOVO LEITO"
    no-close-on-backdrop
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label-required-field label="Número" />
          <b-input ref="autofocus" v-model="number" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Andar</label>
          <b-input v-model="walk" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>ALA/Setor</label>
          <b-input v-model="ward_or_sector" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Quarto</label>
          <b-input v-model="bedroom" />
        </b-col>
      </b-row>
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn
            :disabled="loading"
            class="btn-cancel"
            @click="$bvModal.hide('new_bed')"
          >
            CANCELAR
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn :disabled="loading" type="submit" class="btn-save">
            <i class="fas fa-save mr-2 text-twenty" />
            {{ loading ? "Carregando" : "SALVAR" }}
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";

export default {
  name: "NewBed",

  components: {
    LabelRequiredField,
    WarningRequiredFields,
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],
      loading: false,

      number: "",
      walk: "",
      ward_or_sector: "",
      bedroom: "",
    };
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.number = "";
      this.walk = "";
      this.ward_or_sector = "";
      this.bedroom = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        if (this.number.length > 50)
          this.errors.push("Informe até 50 caracteres no campo Nº");

        if (this.walk.length > 50)
          errors.push("Informe até 50 caracteres no campo Andar");

        if (this.ward_or_sector.length > 50) {
          this.errors.push("Informe até 50 caracteres no campo ALA/Setor");
        }

        if (this.bedroom.length > 50)
          this.errors.push("Informe até 50 caracteres no campo Quarto");

        if (this.errors.length > 0) {
          this.loading = false;
          return;
        }

        const data = {
          number: this.number,
          walk: this.walk,
          ward_or_sector: this.ward_or_sector,
          bedroom: this.bedroom,
        };
        const response = await api.post("/rest-home/bed/create", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("new_bed");
          toast(message, "success");
          this.$emit("created");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>